import { createContext } from 'react';

type LayoutContextData = {
  menuHeight: number;
};

export const LayoutContext = createContext<LayoutContextData>({ menuHeight: 0 });
